import "./App.css";

function App() {
  return (
    <div className="App">
      <header className="App-header">FREE THE FUJOS... SOON</header>
    </div>
  );
}

export default App;
